import { combineReducers } from '@reduxjs/toolkit';
import cache from './cache';
import data from './data';
import queries from './queries';
import values from './values';

const root = combineReducers({ data, cache, queries, values });

export default root;
